document.addEventListener('DOMContentLoaded', function() {
  const toggles = document.querySelectorAll('.kosher-toggle');
  const body = document.body;

  if (toggles.length === 0) return;

  if (localStorage.getItem('kosherMode') === 'enabled') {
      body.classList.add('kosher-mode-active');
      toggles.forEach(toggle => {
          toggle.innerText = 'מעבר לאתר הרגיל';
      });
  }

  toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
          if (localStorage.getItem('kosherMode') === 'enabled') {
              body.classList.remove('kosher-mode-active');
              localStorage.setItem('kosherMode', 'disabled');
              toggles.forEach(t => t.innerText = 'מעבר לאתר המסונן');
          } else {
              body.classList.add('kosher-mode-active');
              localStorage.setItem('kosherMode', 'enabled');
              toggles.forEach(t => t.innerText = 'מעבר לאתר הרגיל');
          }
      });
  });
});